import { createSlice, PayloadAction } from '@reduxjs/toolkit';

import { RouteAnalysisChartData } from '../../models/dashboard/dashboard/route-analysis-data';

interface IInitialState {
  routeAnalysisData: RouteAnalysisChartData[];
}

const initialState: IInitialState = {
  routeAnalysisData: []
};

const routeAnalysisDataSlice = createSlice({
  name: 'routeAnalysisDataSlice',
  initialState,
  reducers: {
    setRouteAnalysisData(state, action: PayloadAction<RouteAnalysisChartData[]>) {
      state.routeAnalysisData = action.payload;
    },
  },
});

export const routeAnalysisDataActions = routeAnalysisDataSlice.actions;
export default routeAnalysisDataSlice.reducer;
